/**
 * @deprecated estimateField.tsを使用してください
 */
const FIELD_NAMES = {
  基板設計: "serviceD",
  基板製造: "serviceM",
  部品実装: "serviceG",
  部品調達: "partsProcurementCourse",
  基板の種類: "kibanType",
  メタル材質: "metalBoard",
  構成層数: "layer",
  パターン面: "patternSide",
  外形寸法x: "sizeX",
  外形寸法y: "sizeY",
  矩形形状: "fpcRectangularShape",
  ピン数: "pinCnt",
  CAD選択: "planCadDataKbn",
  回路図の支給形態: "fileKbn",
  "外形が特殊形状・カードエッジコネクタ": "externalsSilk",
  "固有の仕様書・設計指示書": "designInstruction",
  製造枚数: "cnt",
  実装枚数: "sheetCnt",
  半田種類: "solderType",
  表面実装部品: "pieceCnt",
  本体下に端子が隠れている部品: "bgacsp",
  "実装面 SMD": "sideOfSmd",
  挿入部品: "dipPartCnt",
  "実装面 DIP": "sideOfDip",
  実装方法: "metalmask",
  マウントデータの支給: "provisionOfMountData",
  "メタルマスクの製造・支給選択": "metalMaskDtl",
  "P板.com無料提供部品": "freeMaterialsFlg",
  お客様支給部品: "userProvPartFlg",
  部材到着予定日: "materialsArrivalDate",
  材質: "board",
  板厚: "boardThickness",
  ベース材厚: "fpcBoardThickness",
  "ベース／コアの厚み": "almThickness",
  銅箔厚み: "beatenThickness",
  ビルドアップ工法: "buildUpMethod",
  "最小パターン幅／間隔": "minPattern",
  "最小ビア径／ランド径": "minLand",
  "レーザービア径／ランド径": "laserVia",
  "配置／配線（配線幅・配線長・シールド）ルール": "controlWiring",
  "高電流（10A以上）高電圧（50V以上）多電源（4種以上）": "circuit",
  "BGA／CSP": "planBgacsp",
  "シルク追加10個以上（部品番号・ピン番除く）": "otherSilk",
  特性インピーダンスコントロール: "impedance",
  塗布する面: "resistPrint",
  レジスト色: "resistColor",
  貼る面: "coverLaySide",
  カバーレイ: "coverLay",
  カバーレイ色: "coverLayColor",
  印刷する面: "silk",
  シルク印刷色: "silkColor",
  シルク印刷工法: "silkPrintMethod",
  表面処理: "surfaceFinishing",
  端子部のみ電解金めっき: "hardGoldOnPCIEdgeTerminal",
  端子部の面取り加工: "chamferingProcess",
  端子部厚み指定: "rfContactPortionCnt",
  "仕上り厚み指定（1箇所目）": "rfContactPortion1",
  "端子部厚み指定 接着面（1箇所目）": "rfContactPortionBonding1",
  "仕上り厚み指定（2箇所目）": "rfContactPortion2",
  "端子部厚み指定 接着面（2箇所目）": "rfContactPortionBonding2",
  補強板厚み指定: "reinForcementCnt",
  "厚み指定（1箇所目）": "reinForcement1",
  "補強板厚み指定 接着面（1箇所目）": "reinForcementBonding1",
  "厚み指定（2箇所目）": "reinForcement2",
  "補強板厚み指定 接着面（2箇所目）": "reinForcementBonding2",
  面付け数: "panelizedItemCnt",
  種類: "panelizedItemKindCnt",
  FPC面付けされたデータ: "fpcSurfacePutData",
  Vカット: "vcutCnt",
  ジャンプVカット: "jumpVcutCnt",
  "ルーター切り出し面付け 面付け数": "routerCut",
  "ルーター切り出し面付け 種類": "routerCutKind",
  "ミシン目面付け 面付け数": "roulette",
  "ミシン目面付け 種類": "rouletteKind",
  データ面付け編集サービス: "dataService",
  捨て基板: "discardBoardMark",
  実装認識マーク: "recognizeMark",
  異形外形スリット枠: "editVariantSlit",
  端面スルーホール: "semiTh",
  長穴: "longHole",
  "パッド・オン・ビア": "padOnVia",
  "0.3mm未満のパッド": "padLess03",
  電磁波シールド: "emcShield",
  ULマーク: "ulMark",
  "AOI検査（外観光学検査）": "aoiInspection",
  製造検査成績書: "manufactureInspectionCertificate",
  実装検査成績書: "mountInspectionCertificate",
  データ形式: "dxfData",
  設計CAD: "manuOptPlanCad",
  製造工場: "estManuFactoryId",
  リジッドフレキ基板: "rigidFlexPcb",
  ワイヤーボンディング: "wireBonding",
  "AWデータ支給設計（CAD／LIB必須）": "awDataSupplied",
  面付け: "panelized",
  "DDR I／F・EMC設計（伝送線路シミュレーション等）": "ddrEmc",
  納期短縮対応: "designDaysShortening",
  DXFデータ出力: "dxfDataOutput",
} as const

export default FIELD_NAMES
